var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "templateList"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('li', {
      staticClass: "item",
      attrs: {
        "data-id": item.id
      },
      on: {
        "click": function (event) {
          _vm.click(event, index);
        }
      }
    }, [item.mode == 'process' ? _c('button', [_vm._v(_vm._s(item.publicActive ? "전체공개" : "비공개"))]) : _vm._e(), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    })]), _c('p', {
      staticClass: "title"
    }, [item.field && _vm.listType == 'process' ? _c('span', {
      staticClass: "field"
    }, [_vm._v(_vm._s(item.field))]) : _vm._e(), _c('span', [_vm._v("[" + _vm._s(item.companyCode == '' || item.companyCode == null ? "-" : item.companyCode) + "]")]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })]), _c('p', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.mode == 'process' ? '수정일시' : '공개일시') + " : " + _vm._s(item.updateDate.replace("T", " ")))])])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }